<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动配置编辑</span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="160px" class="demo-ruleForm">
          <el-row>
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="formData.name" style="width: 400px" />
            </el-form-item>
            <el-form-item label="时间范围">
              <el-form-item label="开始时间" prop="start_time">
                <el-date-picker v-model="formData.start_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="开始时间" />
              </el-form-item>
              <el-form-item style="margin-top: 15px" label="结束时间" prop="end_time">
                <el-date-picker v-model="formData.end_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="结束时间" />
              </el-form-item>
            </el-form-item>
            <el-form-item label="本轮时间范围">
              <el-form-item label="开始时间" prop="start">
                <el-date-picker v-model="formData.start" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="开始时间" />
              </el-form-item>
              <el-form-item style="margin-top: 15px" label="结束时间" prop="end">
                <el-date-picker v-model="formData.end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="结束时间" />
              </el-form-item>
            </el-form-item>
            <el-form-item label="活动类型" prop="type">
              <el-select v-model="formData.type" placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="收集物品id" prop="cid">
              <el-input v-model.number="formData.cid" style="width: 400px" />
            </el-form-item>
            <el-form-item label="活动状态" prop="is_online">
              <el-select v-model.number="formData.is_online" placeholder="请选择">
                <el-option
                  v-for="item in actType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="标题名称(多语言KEY)" prop="show_title">
              <el-input v-model="formData.show_title" style="width: 400px" />
            </el-form-item>
            <el-form-item label="是否显示按钮" prop="is_show_b">
              <el-select v-model.number="formData.is_show_b" placeholder="请选择">
                <el-option
                  v-for="item in isShowB"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.is_show_b === 1" label="按钮名字(多语言KEY)" prop="bname">
              <el-input v-model="formData.bname" style="width: 400px" />
            </el-form-item>
            <el-form-item v-if="formData.is_show_b === 1" label="按钮颜色" prop="bcolor">
              <el-select v-model.number="formData.bcolor" placeholder="请选择">
                <el-option
                  v-for="item in bcolorType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.is_show_b === 1" label="按钮跳转位置" prop="bskip">
              <el-input v-model.number="formData.bskip" style="width: 400px" />
            </el-form-item>
            <el-form-item v-if="formData.is_show_b === 1" label="按钮跳转网页地址" prop="burl">
              <el-input v-model="formData.burl" style="width: 400px" />
            </el-form-item>
            <el-form-item label="资源所在位置下标" prop="img">
              <el-input v-model="formData.img" style="width: 400px" />
            </el-form-item>
            <el-form-item label="资源所在位置目录名" prop="imgName">
              <el-input v-model="formData.imgName" style="width: 400px" />
            </el-form-item>
            <el-form-item label="活动券" prop="act_coupon_skin">
              <el-input v-model="formData.act_coupon_skin" style="width: 400px" />
            </el-form-item>
            <el-form-item label="关闭时间" prop="lock_time">
              <el-input v-model.number="formData.lock_time" style="width: 400px" />
            </el-form-item>
            <el-form-item label="文字颜色" prop="textColor">
              <el-input v-model="formData.textColor" style="width: 400px" />
            </el-form-item>
            <el-form-item label="领奖时间" prop="reward_time">
              <el-date-picker v-model.trim="formData.reward_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" />
            </el-form-item>
            <el-form-item label="客户端类型" prop="client">
              <el-select v-model.number="formData.is_show_b" placeholder="请选择">
                <el-option
                  v-for="item in clientType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="游客类型" prop="user_type">
              <el-select v-model.number="formData.user_type" placeholder="请选择">
                <el-option
                  v-for="item in clientType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="参与等级范围">
              <el-form :inline="true">
                <el-form-item>
                  <el-input v-model.number="formData.user_level_min" style="width: 200px" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="formData.user_level_max" style="width: 200px" />
                </el-form-item>
              </el-form>
            </el-form-item>
            <el-form-item label="vip等级区间">
              <el-form :inline="true">
                <el-form-item>
                  <el-input v-model="formData.user_vip_min" style="width: 200px" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model="formData.user_vip_max" style="width: 200px" />
                </el-form-item>
              </el-form>
            </el-form-item>

            <el-form-item label="vip分数区间">
              <el-form :inline="true">
                <el-form-item>
                  <el-input v-model="formData.user_score_min" style="width: 200px" />
                </el-form-item>

                <el-form-item label="-">
                  <el-input v-model="formData.user_score_max" style="width: 200px" />
                </el-form-item>
              </el-form>
            </el-form-item>
            <el-form-item label="循环类型" prop="loop_type">
              <el-select v-model.number="formData.loop_type" placeholder="请选择">
                <el-option
                  v-for="item in loopType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="循环周期" prop="loop_num">
              <el-input v-model.number="formData.loop_num" style="width: 400px" />
            </el-form-item>
            <el-form-item v-if="formData.type === 'rank' ||formData.type === 'super_collect' ||formData.type === 'super_collect2' || formData.type === 'super_collect3' " label="奖励进度获取配置" prop="reward_conf">
              <el-card>
                <el-form :inline="true">
                  <el-form-item label="分组" style="margin-top: 5px" prop="steal_break">
                    <el-select v-model.number="formData.reward_conf.groupId" placeholder="请选择">
                      <el-option
                        v-for="item in groupType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="numShow" label="金币地块数" style="margin-top: 5px" prop="steal_break">
                    <el-input v-model.number="formData.reward_conf.num" style="width: 200px" />
                  </el-form-item>
                </el-form>
                <el-form :inline="true">
                  <el-row v-for="(item, i) in formData.reward_conf.collect" :key="i">
                    <el-form-item label="类型" style="margin-top: 5px;" prop="steal_break">
                      <el-select v-model="item.type" placeholder="请选择类型" @change="(v)=>{ return selectTypeChange(v)}">
                        <el-option v-for="(item, index) in selectType" :key="index" :disabled="item.disabled" :label="item.title" :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="倍数" style="margin-top: 5px" prop="steal_break">
                      <el-input v-model.number="item.bet" style="width: 200px" />
                    </el-form-item>
                    <el-form-item style="margin-top: 5px">
                      <el-button type="danger" @click="delCollect(i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                </el-form>
                <el-button style="margin-top: 5px" type="primary" @click="addCollect">+</el-button>
              </el-card>
            </el-form-item>
            <el-form-item label="用户群体" prop="uc_type">
              <el-select v-model.number="formData.uc_type" placeholder="请选择">
                <el-option
                  v-for="item in ucType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="版本" prop="act_version">
              <el-input v-model="formData.act_version" style="width: 400px" />
            </el-form-item>
            <el-form-item label="AB Test分组" prop="abTest">
              <el-select v-model.number="formData.abTest" placeholder="请选择">
                <el-option
                  v-for="item in abTestType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否发生推送" prop="openPush">
              <el-select v-model.number="formData.openPush" placeholder="请选择">
                <el-option
                  v-for="item in openPushType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.type === 'super_collect' || formData.type === 'super_collect2'" label="是否有spin动画" prop="isShowSpine">
              <el-select v-model.number="formData.extraData.isShowSpine" placeholder="请选择">
                <el-option
                  v-for="item in openPushType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.type === 'super_collect' || formData.type === 'super_collect2'" label="开启限时活动" prop="open">
              <el-select v-model.number="formData.extraData.open" placeholder="请选择">
                <el-option
                  v-for="item in openPushType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否向下兼容版本" prop="isComVersion">
              <el-select v-model.number="formData.isComVersion" placeholder="请选择">
                <el-option
                  v-for="item in isComVersionType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="abtest类型" prop="abType">
              <el-select v-model.number="formData.abType" placeholder="请选择">
                <el-option
                  v-for="item in abType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="数数分群id" prop="taTest">
              <el-input v-model.number="formData.taTest" style="width: 400px" />
            </el-form-item>
            <el-form-item label="优先级" prop="priority">
              <el-input v-model.number="formData.priority" style="width: 400px" />
            </el-form-item>
            <el-form-item label="是否为隐藏" prop="ishide">
              <el-select v-model.number="formData.ishide" placeholder="请选择">
                <el-option
                  v-for="item in openPushType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="submitForm('formData')">保存</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActivityList, getActivityTypesList, getCollectTypesList, updateActivityCfg } from '@/api/config/activity-cfg'
export default {
  name: 'ActivityConfigEdit',
  data() {
    return {
      types: [],
      actType: [{ label: '上线', value: 1 }, { label: '下线', value: 0 }],
      isShowB: [{ label: '显示', value: 1 }, { label: '隐藏', value: 0 }],
      clientType: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'IOS', value: 2 }],
      userType: [{ label: '全部', value: 0 }, { label: 'FB', value: 1 }, { label: '游客', value: 2 }],
      loopType: [{ label: '单次', value: 1 }, { label: '小时', value: 2 }, { label: '天', value: 3 }],
      ucType: [{ label: '常规活动', value: 0 }, { label: '道具型活动', value: 1 }],
      abTestType: [{ label: '默认', value: 0 }, { label: 'A组', value: 1 }, { label: 'B组', value: 2 }],
      openPushType: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      isComVersionType: [{ label: '是', value: 0 }, { label: '否', value: 1 }],
      abType: [{ label: '关闭', value: 0 }, { label: 'firebase', value: 1 }, { label: '数数分群', value: 2 }],
      bcolorType: [
        { label: '蓝色', value: 1 },
        { label: '红色', value: 2 },
        { label: '绿色', value: 3 },
        { label: '灰色', value: 4 },
        { label: '橙色', value: 5 }
      ],
      formData: {
        'Id': 0,
        'cid': '',
        'name': '',
        'name_en': '',
        'start_time': '',
        'end_time': '',
        'start': '',
        'end': '',
        'is_online': 0,
        'show_title': '',
        'status': 0,
        'is_show_b': 0,
        'bname': '',
        'bcolor': 0,
        'bskip': 0,
        'burl': '',
        'img': '',
        'imgName': '',
        'act_coupon_skin': 0,
        'lock_time': '',
        'textColor': '',
        'reward_time': '',
        'client': 0,
        'user_type': 0,
        'user_level_section': '-',
        'user_level_min': 0,
        'user_level_max': 0,
        'user_vip_section': '-',
        'user_vip_min': 0,
        'user_vip_max': 0,
        'user_score_section': '-',
        'user_score_min': 0,
        'user_score_max': 0,
        'loop_type': 1,
        'loop_num': 0,
        'reward_conf': {
          groupId: 1,
          num: 0,
          collect: []
        },
        'reward_pro': [{ k: 1, v: 1 }],
        'uc_type': 0,
        'act_version': '',
        'abTest': 0,
        'openPush': 0,
        'joinNum': 0,
        'country': 0,
        'isComVersion': 0,
        'abType': 0,
        'taTest': 0,
        'priority': 0,
        'ishide': 0,
        extraData: {
          isShowSpine: 0
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择活动类型', trigger: 'blur' }
        ],
        start_time: [
          { required: true, message: '时间范围-请选择开始时间', trigger: 'blur' }
        ],
        end_time: [
          { required: true, message: '时间范围-请选择开始时间', trigger: 'blur' }
        ],
        // start: [
        //   { required: true, message: '本轮时间范围-请选择开始时间', trigger: 'blur' }
        // ],
        // end: [
        //   { required: true, message: '本轮时间范围-请选择开始时间', trigger: 'blur' }
        // ],
        show_title: [
          { required: true, message: '请输入标题名称', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请输入资源所在位置下标', trigger: 'blur' }
        ],
        imgName: [
          { required: true, message: '请输入资源所在位置目录名', trigger: 'blur' }
        ],
        bname: [
          { required: true, message: '请输入按钮名字', trigger: 'blur' }
        ],
        bcolor: [
          { required: true, message: '请输入按钮颜色', trigger: 'blur' }
        ],
        bskip: [
          { required: true, message: '请输入跳转位置', trigger: 'blur' }
        ],
        burl: [
          { required: true, message: '请输入按钮跳转网页', trigger: 'blur' }
        ],
        // act_coupon_skin: [
        //   { required: true, message: '请输入活动券皮肤', trigger: 'blur' }
        // ],
        lock_time: [
          { required: true, message: '请输入关闭时间', trigger: 'blur' }
        ],
        // textColor: [
        //   { required: true, message: '请输入文字颜色', trigger: 'blur' }
        // ],
        reward_time: [
          { required: true, message: '请选择领奖时间', trigger: 'blur' }
        ],
        // user_level_min: [
        //   { required: true, message: '请输入参与等级范围', trigger: 'blur' }
        // ],
        // user_level_max: [
        //   { required: true, message: '请输入参与等级范围', trigger: 'blur' }
        // ],
        user_vip_section: [
          { required: true, message: '请输入vip等级区间', trigger: 'blur' }
        ],
        user_score_section: [
          { required: true, message: '请输入vip分数区间', trigger: 'blur' }
        ],
        loop_num: [
          { required: true, message: '请输入循环周期', trigger: 'blur' }
        ],
        rewardPro: [
          { required: true, type: 'array', message: '请输入奖励触发概率配置', trigger: 'blur' }
        ],
        // reward_pro: [
        //   { required: true, type: 'array', message: '请输入奖励触发概率配置', trigger: 'blur' }
        // ],
        // act_version: [
        //   { required: true, message: '请输入版本', trigger: 'blur' }
        // ],
        joinNum: [
          { required: true, message: '请输入本次活动参与人数', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入优先级', trigger: 'blur' }
        ]
      },
      groupType: [
        { label: '常规收集', value: 1 },
        { label: '特殊收集', value: 2 },
        { label: '特殊收集偷', value: 3 },
        { label: '特殊收集打', value: 4 },
        { label: '偷', value: 5 },
        { label: '打', value: 6 },
        { label: '特殊收集+偷+打', value: 7 },
        { label: '收集偷', value: 8 },
        { label: '收集打', value: 9 }
      ],
      numShow: false,
      selectType: [],
      exactArr: [6, 7, 8, 9, 10, 11, 12]
    }
  },
  created() {
    this.getActivityTypes()
    this.getChessBoardType()
    const id = this.$route.query.id
    if (id > 0) {
      this.getTables(id)
    }
  },
  methods: {
    selectTypeChange(v, $event) {
      this.selectType.forEach((item, index) => {
        if (item.id === v) {
          this.selectType[index].disabled = true
        }
      })
      this.listenChangeType()
    },
    addCollect() {
      this.listenChangeType()
      let selectVal = ''
      const selectType = this.selectType

      for (const i in selectType) {
        if (!selectType[i].disabled) {
          selectVal = selectType[i].id
          this.selectType[i].disabled = true
          break
        }
      }

      if (!selectVal) {
        this.msgError('没有可选的类型')
        return
      }

      this.formData.reward_conf.collect.push({
        type: selectVal,
        bet: 0
      })
      this.listenChangeType()
    },
    listenChangeType() {
      // console.log('listenChangeType')
      const collect = this.formData.reward_conf.collect
      this.numShow = false
      for (const index in this.selectType) {
        this.selectType[index].disabled = false
        for (const i in collect) {
          if (collect[i].type === this.selectType[index].id && !this.selectType[index].disabled) {
            this.selectType[index].disabled = true
            if (this.selectType[index].id === 5 && !this.numShow) {
              this.numShow = true
            }
            break
          }
        }
      }
    },
    delCollect(i) {
      this.formData.reward_conf.collect = this.formData.reward_conf.collect.filter((item, index) => {
        return i !== index
      })
      this.listenChangeType()
    },
    getChessBoardType() {
      getCollectTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i), disabled: false })
          }
        }
      })
    },
    getTables(id) {
      getActivityList({ id: id }).then(res => {
        if (res.code === 200) {
          // for (const k in res.data.list[0]) {
          //   this.formData[k] = res.data.list[0][k]
          // }
          this.formData = res.data.list[0]
          const [level_min, level_max] = this.formData.user_level_section.split('-')
          this.$set(this.formData, 'user_level_min', level_min)
          this.$set(this.formData, 'user_level_max', level_max)

          const [score_min, score_max] = this.formData.user_score_section.split('-')
          this.$set(this.formData, 'user_score_min', score_min)
          this.$set(this.formData, 'user_score_max', score_max)

          const [vip_min, vip_max] = this.formData.user_vip_section.split('-')
          this.$set(this.formData, 'user_vip_min', vip_min)
          this.$set(this.formData, 'user_vip_max', vip_max)
          const collect = this.formData.reward_conf.collect
          const newCollect = []
          this.numShow = false
          for (const k in collect) {
            const _type = parseInt(k)
            if (!this.exactArr.includes(_type)) {
              newCollect.push({ type: _type, bet: collect[k] })
            }
          }
          this.formData.reward_conf.groupId = parseInt(this.formData.reward_conf.groupId)
          this.$set(this.formData.reward_conf, 'collect', newCollect)
          this.listenChangeType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const formData = this.formData
          if (formData.user_level_min > formData.user_level_max) {
            this.msgError('参与等级范围-最小等级不能大于最大等级')
            return
          }
          if (formData.user_vip_min > formData.user_vip_max) {
            this.msgError('vip等级区间-最小等级不能大于最大等级')
            return
          }
          if (formData.user_score_min > formData.user_score_max) {
            this.msgError('vip分数区间-最小分数不能大于最大分数')
            return
          }

          this.formData.user_level_section = formData.user_level_min + '-' + formData.user_level_max
          this.formData.user_vip_section = formData.user_vip_min + '-' + formData.user_vip_max
          this.formData.user_score_section = formData.user_score_min + '-' + formData.user_score_max
          for (const k in this.formData) {
            const val = this.formData[k]
            if (k === 'reward_pro') {
              for (const k in val) {
                const _data = val[k]
                if (_data.bet === '') {
                  this.msgError('倍数不能为空')
                  return
                }
              }
            }
          }

          const newFormData = this.formData
          const groupId = newFormData.reward_conf.groupId
          const collect = newFormData.reward_conf.collect
          const num = newFormData.reward_conf.num
          const newCollect = { num: num, groupId: groupId, collect: {}}
          let selectNumBet = 0
          for (const i in collect) {
            const _collect = collect[i]
            newCollect.collect[_collect.type] = _collect.bet
            if (_collect.type === 5) {
              selectNumBet = _collect.bet
            }
          }
          // 加入金币
          if (this.numShow) {
            for (let i = 6; i <= 12; i++) {
              newCollect.collect[i] = selectNumBet
            }
          }
          // console.log('newCollect', newCollect)
          newFormData.reward_conf = newCollect
          const data = JSON.stringify(newFormData)
          // console.log(data)
          updateActivityCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/activity-config/index' })
              this.$nextTick(() => {
                this.$root.$emit('fetchData') // 发送事件通知列表页更新数据
              })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getActivityTypes() {
      getActivityTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delRewardPro(k) {
      this.formData.reward_pro = this.formData.reward_pro.filter((res, i) => {
        return k !== i
      })

      let count = 0
      this.formData.reward_pro.forEach((item, index) => {
        count++
        this.formData.reward_pro[index].k = count
      })
    },
    addRewardPro() {
      const len = this.formData.reward_pro.length
      this.formData.reward_pro.push({
        k: len + 1,
        v: 0
      })
    }

  }
}
</script>

<style scoped>
</style>
